export namespace Random {
    export function range(a: number, b: number) {
        return Math.floor(Math.random() * (b - a + 1)) + a;
    }
}